module.exports = __webpack_public_path__ + "static/media/consumer-benefit.23a43e5a.svg";